"use client";

import {
  buildItemListId,
  buildItemListName,
} from "@/lib/analytics/ecommerce-analytics";

import { useProductSearchEvent } from "@/hooks/useProductSearchEvent";

import { CategoryProducts } from "../actions";

export function ShopProductSearchEvent({
  products,
  category,
  search,
}: ShopProductSearchEventProps) {
  useProductSearchEvent(search, products, {
    itemListId: buildItemListId(category),
    itemListName: buildItemListName(category),
  });

  return null;
}

type ShopProductSearchEventProps = {
  products: CategoryProducts;
  category: string;
  search: string;
};
